import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

export const HelpMsg = ({ caption }) => (
  <>
    <HelpOutlineIcon />
    &nbsp;&nbsp; {caption}
  </>
)
